// extracted by mini-css-extract-plugin
module.exports = {"small_statistics_container":"SmallCharts_small_statistics_container__2Yxds","button_switch":"SmallCharts_button_switch__13YJl","active":"SmallCharts_active__3eyYg"};